import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IWorkOrderPartsResponse } from "../models/WorkOrder";

export default function useWorkOrderParts(workOrderId: string | null | undefined, enabled: boolean = true) {
  const { get } = useApiHelper();

  return useQuery({
    queryKey: ["workOrderParts", workOrderId],
    queryFn: () => get<IWorkOrderPartsResponse>(`/workorder/${workOrderId}/parts`),
    enabled: enabled && !!workOrderId,
    staleTime: 1000 * 30,
  });
}
